export default __webpack_public_path__ + "c5819e25dc9b2317f04931fa2fe51e80.svg";